import {
  generic_get_network_request,
  generic_post_network_request,
  generic_delete_network_request,
} from '../axiosClient/axiosClient';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface ConnectedForm_Type {
  connection_id: number;
  file_id: number;
  form_id: number;
  s3_path: string;
  created_at: string;
  is_active: number;
  // Count of submissions across all assignments for this file's connected form.
  // Returned by the connected-forms-by-company endpoint so the per-file
  // "View Submissions" icon can render without a separate per-file query.
  submission_count: number;
}

export interface GetConnectedForms_Response_Type {
  data: ConnectedForm_Type[];
}

export interface ConnectForm_Payload_Type {
  file_id: number;
  form_id: number;
  company_id: number;
  library_id: number;
  created_by: number;
  file_name: string;
}

export interface ConnectForm_Response_Type {
  data: { connection_id: number }[];
}

export interface DisconnectForm_Response_Type {
  success: boolean;
}

// ─── API Functions ────────────────────────────────────────────────────────────

export const getConnectedFormsByFile = (api_endpoint: string) =>
  generic_get_network_request<GetConnectedForms_Response_Type>(api_endpoint);

export const getConnectedFormsByCompany = (api_endpoint: string) =>
  generic_get_network_request<GetConnectedForms_Response_Type>(api_endpoint);

export const connectForm = (payload: ConnectForm_Payload_Type) =>
  generic_post_network_request<ConnectForm_Response_Type, ConnectForm_Payload_Type>(
    'connected-forms',
    payload
  );

export const disconnectForm = (connection_id: number) =>
  generic_delete_network_request<DisconnectForm_Response_Type>(
    `connected-forms/${connection_id}`
  );
